import PropTypes from 'prop-types';
import React, { useCallback, useContext, useState } from 'react';

import { CommunityContext } from '../../../../context/ContextCreator';
import { EmitMetric } from '../../../../utils/Analytics/VisibilityPixel/VisibilityPixel';
import useUser from '../../../../utils/useUser';
import ConfirmationPopup from '../../../Elements/ConfirmationPopup';

const ModerationDelete = ({ hash, onHandleDelete }) => {
    const { getContent, deleteCommunityContent } = useContext(CommunityContext);
    const { user } = useUser();
    const { isLoggedIn, id, username } = user;
    const [showDeleteMenu, setShowDeleteMenu] = useState(false);

    const content = getContent(hash);

    const handleDeleteClick = useCallback(() => {
        if (!isLoggedIn) return;
        EmitMetric({
            community_content_key: `${content.type}-${hash}`,
            misc_event_count: 1,
            misc_event_type: 'delete_content_clicked',
        });
        if (!showDeleteMenu) setShowDeleteMenu(true);
    }, [content.type, hash, isLoggedIn, showDeleteMenu]);

    const handleCloseDeleteModal = useCallback(() => {
        if (showDeleteMenu) setShowDeleteMenu(false);
    }, [showDeleteMenu]);

    const handleDelete = useCallback(() => {
        deleteCommunityContent(content.type, hash);
        if (onHandleDelete) onHandleDelete();
        handleCloseDeleteModal();
    }, [
        deleteCommunityContent,
        handleCloseDeleteModal,
        hash,
        content.type,
        content.hash,
        id,
        username,
    ]);

    return (
        <>
            <div
                className="component-ModerationDelete"
                onClick={handleDeleteClick}
                onKeyPress={handleDeleteClick}
                role="button"
                tabIndex={0}
            >
                <style jsx>
                    {`
                        .component-ModerationDelete {
                            display: flex;
                            align-items: center;
                            width: 100%;
                        }
                        .component-ModerationDelete:focus {
                            outline: none;
                        }
                        .component-ModerationDelete .moderationDelete-label {
                            font-size: 14px;
                            line-height: 34px;
                            color: #353535;
                            padding-top: 2px;
                        }
                    `}
                </style>
                <span className="moderationDelete-label">Delete</span>
            </div>
            <div>
                {showDeleteMenu && (
                    <ConfirmationPopup
                        onClose={handleCloseDeleteModal}
                        cssClass="delete-confirmation"
                        heading={`Are you sure you want to delete this ${
                            content.type === 'community-comment'
                                ? 'comment'
                                : 'post'
                        }?`}
                        subheading="This cannot be undone."
                        imageSrc="v1562791783/EditDelete/deletemodule_trashcan.svg"
                        buttonMetas={[
                            {
                                onClickHandler: handleDelete,
                                buttonText: 'Yes',
                                buttonType: 'primary',
                            },
                            {
                                onClickHandler: handleCloseDeleteModal,
                                buttonText: 'No',
                                buttonType: 'secondary',
                            },
                        ]}
                    />
                )}
            </div>
        </>
    );
};

ModerationDelete.propTypes = {
    hash: PropTypes.string.isRequired,
    onHandleDelete: PropTypes.func,
};
ModerationDelete.defaultProps = {
    onHandleDelete: () => {},
};

ModerationDelete.displayName = 'ModerationDelete';

export default ModerationDelete;
